export default __webpack_public_path__ + "static/media/rocket.dba0d066.svg";